function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: CHECKRECIPIENT opcode — verify transaction pays script publickey.
 */

module.exports = {
  name: 'CHECKRECIPIENT',
  description: 'Verify a transaction output pays the required publickey.',
  exampleScript: {
    op: 'CHECKRECIPIENT',
    publickey: '<publickey>'
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    var tx = context.tx;
    if (!tx || _typeof(tx) !== 'object' || Array.isArray(tx)) {
      return false;
    }
    var publickey = node.publickey;
    if (typeof publickey !== 'string' || publickey.length === 0) {
      return false;
    }
    var required = publickey.toLowerCase();
    var outputs = tx.to;
    if (Array.isArray(outputs)) {
      for (var i = 0; i < outputs.length; i += 1) {
        var slip = outputs[i];
        if (!slip || _typeof(slip) !== 'object') {
          continue;
        }
        var pk = slip.publicKey || slip.publickey || slip.address;
        if (typeof pk === 'string' && pk.toLowerCase() === required) {
          return true;
        }
      }
      return false;
    }
    if (typeof outputs === 'string' && outputs.length > 0) {
      return outputs.toLowerCase() === required;
    }
    var altOutputs = tx.outputs;
    if (Array.isArray(altOutputs)) {
      for (var _i = 0; _i < altOutputs.length; _i += 1) {
        var _slip = altOutputs[_i];
        if (!_slip || _typeof(_slip) !== 'object') {
          continue;
        }
        var _pk = _slip.publicKey || _slip.publickey || _slip.address;
        if (typeof _pk === 'string' && _pk.toLowerCase() === required) {
          return true;
        }
      }
    }
    return false;
  }
};